import axios from 'axios';
import * as qs from 'qs';
import resolvePath from 'utils/resolvePath';
// Action
const FORWARD = 'notification/forward';
const CLEAR = 'notification/clear';
const GET_NOTIFICATIONS_REQUEST = 'notification/getNotificationsRequest';
const GET_NOTIFICATIONS_SUCCESS = 'notification/getNotificationsSuccess';
const GET_NOTIFICATIONS_FAILURE = 'notification/getNotificationsFailure';
const GET_NOTIFICATIONS_ID_REQUEST = 'notification/getNotificationsIdRequest';
const GET_NOTIFICATIONS_ID_SUCCESS = 'notification/getNotificationsIdSuccess';
const GET_NOTIFICATIONS_ID_FAILURE = 'notification/getNotificationsIdFailure';
const SELECT_TYPE = 'notification/selectType';
// Action Creator
export const forward = () => {
    return {
        type: FORWARD,
    };
};
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getNotificationsRequest = () => {
    return {
        type: GET_NOTIFICATIONS_REQUEST,
    };
};
export const getNotificationsSuccess = (notifications) => {
    return {
        payload: {
            notifications,
        },
        type: GET_NOTIFICATIONS_SUCCESS,
    };
};
export const getNotificationsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_NOTIFICATIONS_FAILURE,
    };
};
export const getNotifications = (authToken, parameters) => {
    return (dispatch) => {
        dispatch(getNotificationsRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(`${resolvePath.api('notifications')}?${qs.stringify(parameters)}`, config)
            .then((response) => dispatch(getNotificationsSuccess(response.data)))
            .catch((error) => {
            dispatch(getNotificationsFailure(error));
            throw error;
        });
    };
};
export const getNotificationsIdRequest = () => {
    return {
        type: GET_NOTIFICATIONS_ID_REQUEST,
    };
};
export const getNotificationsIdSuccess = (notification) => {
    return {
        payload: {
            notification,
        },
        type: GET_NOTIFICATIONS_ID_SUCCESS,
    };
};
export const getNotificationsIdFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_NOTIFICATIONS_ID_FAILURE,
    };
};
export const getNotificationsId = (authToken, id) => {
    return (dispatch) => {
        dispatch(getNotificationsIdRequest());
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };
        return axios
            .get(resolvePath.api(`notifications/${id}`), config)
            .then((response) => dispatch(getNotificationsIdSuccess(response.data)))
            .catch((error) => {
            dispatch(getNotificationsIdFailure(error));
            throw error;
        });
    };
};
export const selectType = (type) => {
    return {
        payload: {
            type,
        },
        type: SELECT_TYPE,
    };
};
export const initialState = {
    error: undefined,
    isFetching: false,
    meta: {
        current_page: 0,
        next_page: null,
        per_page: 0,
        previous_page: 0,
        total_entries: 0,
        total_pages: 0,
    },
    notification: {
        body: '',
        conversation_id: 0,
        id: 0,
        image_url: '',
        notificated_at: '',
        related_user: null,
        notification_type: 0,
        title: '',
    },
    notifications: [],
    page: 1,
    selectedType: -1,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FORWARD: {
            return Object.assign(Object.assign({}, state), { page: state.page + 1 });
        }
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { notifications: [], page: 1 });
        }
        case GET_NOTIFICATIONS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_NOTIFICATIONS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, meta: Object.assign({}, action.payload.notifications.meta), notifications: state.notifications.concat(action.payload.notifications.data) });
        }
        case GET_NOTIFICATIONS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_NOTIFICATIONS_ID_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_NOTIFICATIONS_ID_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, notification: action.payload.notification });
        }
        case GET_NOTIFICATIONS_ID_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case SELECT_TYPE: {
            return Object.assign(Object.assign({}, state), { selectedType: action.payload.type });
        }
        default: {
            return state;
        }
    }
};
